/* Feedback Page
  -> entry point + router
*/

import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import { CSSTransition } from 'react-transition-group';

import { loadLocales } from 'services/translation';

import AnimationWrapper from './components/AnimationWrapper';
import Header from './components/Header';
import FormContainer from './components/FormContainer';
import ThankYou from './components/ThankYou';

class Feedback extends Component {
  constructor(props) {
    super(props);

    // Load feedback into state to pass to children
    // in order to persist between page back/forward
    const { feedback, experienceQuestions } = this.props;
    this.state = { feedback, experienceQuestions };

    // Load locales from booking
    loadLocales(feedback.attributes.booking.data.attributes.i18n || 'en-US');
  }

  loadFeedback = ({ feedback, experienceQuestions }) => {
    this.setState({
      feedback,
      experienceQuestions,
    });
  };

  determineAnimation = (location) => {
    if (location.pathname === '/') return 'fadeLeft';
    return 'fadeRight';
  };

  render() {
    const { brand, settings } = this.props;
    const { feedback, experienceQuestions } = this.state;
    const childProps = {
      brand,
      feedback,
      settings,
      experienceQuestions,
    };

    return (
      <AnimationWrapper>
        <Router basename={`/tya/feedback/${feedback.id}`}>
          <Route
            render={({ location }) => (
              <div>
                <Header {...brand} borderBottom />

                <TransitionGroup component="div">
                  <CSSTransition
                    key={location.key}
                    classNames={this.determineAnimation(location)}
                    timeout={{ enter: 100, exit: 100 }}
                    appear
                    in
                  >
                    <div>
                      <Switch location={location}>
                        <Route
                          path="/thank_you"
                          render={(props) => (
                            <ThankYou {...props} {...childProps} />
                          )}
                        />
                        <Route
                          path="/"
                          render={(props) => (
                            <FormContainer
                              {...props}
                              {...childProps}
                              loadFeedback={this.loadFeedback}
                            />
                          )}
                        />
                        <Route render={() => <div>404 Not Found</div>} />
                      </Switch>
                    </div>
                  </CSSTransition>
                </TransitionGroup>
              </div>
            )}
          />
        </Router>
      </AnimationWrapper>
    );
  }
}

export default Feedback;
